// extracted by mini-css-extract-plugin
export default {"footer":"ModelPicker-module__footer--sZ10q"};